import styled from "styled-components";

export const SearchContainer = styled.form`
  input[name="searchInput"] {
    width: 75%;
  }
`;
